<template>
  <div class="supportContainer">
    <div v-if="!loading" style="margin-bottom: 40px">
      <div>
        <v-card elevation="0" style="
            height: 56px;
            margin: 20px;
            border-radius: 4px !important;
            margin-top: 35px;
          ">
          <v-card-title class="py-2 my- d-flex align-center justify-center">
            <v-badge color="success" v-if="status == 2" content="مكتملة" floating class="py-2"></v-badge>
            {{ clientName }}
            <svg v-if="QualityRequest" @click="to_request_details()" class="mr-4 mt-1"
              xmlns="http://www.w3.org/2000/svg" width="16.1" height="11.982" viewBox="0 0 16.1 11.982" style="
                background: #40be72;
                width: 32px;
                height: 32px;
                border-radius: 50%;
                padding: 7px;
                cursor: pointer;
              ">
              <g id="Group_11443" data-name="Group 11443" transform="translate(-765.437 -394.636)">
                <g id="Icon_feather-eye" data-name="Icon feather-eye" transform="translate(765.937 395.136)">
                  <path id="Path_3993" data-name="Path 3993"
                    d="M1.5,11.491S4.246,6,9.05,6s7.55,5.491,7.55,5.491-2.746,5.491-7.55,5.491S1.5,11.491,1.5,11.491Z"
                    transform="translate(-1.5 -6)" fill="none" stroke="#fff" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="1" />
                  <path id="Path_3994" data-name="Path 3994"
                    d="M17.618,15.559A2.059,2.059,0,1,1,15.559,13.5,2.059,2.059,0,0,1,17.618,15.559Z"
                    transform="translate(-8.009 -10.068)" fill="none" stroke="#fff" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="1" />
                </g>
              </g>
            </svg>
          </v-card-title>
        </v-card>

        <div v-for="item in ticket_details" :key="item.id">
          <div class="lightArrow" v-if="item.position_of_message == 'left'">
            <div style="text-align: end" class="dateContainer">
              <div>
                {{ item.created_at.replace(" ", " ,").split(" ,")[0] }}
              </div>
              <div>
                {{ item.created_at.replace(" ", " ,").split(" ,")[1] }}
              </div>
            </div>
            <img src="@/assets/arrowLight.svg" />
            <div style="width: 60px; height: 2px; background: #4d204d"></div>
            <div class="problemContainer">
              <div class="customerName">{{ item.name ?? item.user?.name }}</div>
              
              <!-- Enhanced File Display -->
              <div v-if="item.images.length > 0" class="files-container">
                <div v-for="(image, index) in item.images" :key="index" class="file-item">
                  <div class="file-preview" @click="openFile(image.image_path)">
                    <div class="file-icon">
                      <v-icon size="24" color="#4d204d">mdi-file-image</v-icon>
                    </div>
                    <div class="file-info">
                      <div class="file-name">ملف مرفق</div>
                      <div class="file-action">انقر للعرض</div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <v-row>
                  <v-col cols="12" sm="12">
                    <div>
                      <span>
                        {{ item.descrebtion }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>

          <div class="darkArrow" v-if="item.position_of_message == 'right'">
            <div class="problemContainer">
              <div class="customerName">
                {{ item.name ?? item.user?.name }}
              </div>

              <!-- Enhanced File Display -->
              <div v-if="item.images.length > 0" class="files-container">
                <div v-for="(image, index) in item.images" :key="index" class="file-item">
                  <div class="file-preview" @click="openFile(image.image_path)">
                    <div class="file-icon">
                      <v-icon size="24" color="white">mdi-file-image</v-icon>
                    </div>
                    <div class="file-info">
                      <div class="file-name">ملف مرفق</div>
                      <div class="file-action">انقر للعرض</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>{{ item.descrebtion }}</div>
            </div>
            <div style="width: 60px; height: 2px; background: #4d204d"></div>
            <img src="@/assets/arrowDark.svg" />
            <div class="dateContainer">
              <div>
                {{ item.created_at.replace(" ", " ,").split(" ,")[0] }}
              </div>
              <div>
                {{ item.created_at.replace(" ", " ,").split(" ,")[1] }}
              </div>
            </div>
          </div>
        </div>

        <v-card elevation="0" v-if="showReplyTextbox">
          <v-card-title class="ma-5 d-flex align-center justify-center">
            الرد
          </v-card-title>

          <!-- Enhanced File Upload Preview -->
          <div v-if="files.length > 0" class="uploaded-files-preview mx-10 mb-3">
            <div class="upload-header">
              <span>الملفات المحددة ({{ files.length }})</span>
              <v-btn icon small @click="clearFiles">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </div>
            <div class="uploaded-files-list">
              <div v-for="(file, index) in files" :key="index" class="uploaded-file-item">
                <div class="file-preview-upload">
                  <v-icon color="#4d204d" size="20">mdi-file</v-icon>
                  <span class="file-name-upload">{{ file.name }}</span>
                  <v-btn icon x-small @click="removeFile(index)">
                    <v-icon x-small color="error">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>

          <!-- Textarea with Attach Icon -->
          <v-textarea v-model="replay" class="mx-10 mb-5" outlined placeholder="أكتب رسالتك">
            <!-- Append icon slot -->
            <template #append>
              <v-btn icon @click="triggerFileUpload">
                <v-icon>mdi-paperclip</v-icon>
              </v-btn>
              <!-- Hidden file input -->
              <input type="file" ref="fileInput" multiple class="d-none py-5" @change="handleFileUpload" />
            </template>
          </v-textarea>

          <v-card-actions class="d-flex align-center justify-center">
            <v-btn :loading="reply_loading" color="primary" @click="reply_ticket_content" class="font-weight-bold">إرسال</v-btn>
          </v-card-actions>
        </v-card>

        <v-card elevation="0">
          <v-card-actions class="d-flex align-center justify-center" v-if="this.ticket_details[0].status === 2">
            <v-btn color="success" class="font-weight-bold">التذكرة مكتملة</v-btn>
          </v-card-actions>

          <v-card-actions class="d-flex align-center justify-center" v-if="this.ticket_details[0].status === 2">
            <v-btn style="background-color: #4d204d; color: white" @click="reOpenTicket" class="font-weight-bold">{{
              changeContentOfButton() }}</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  props: ["agent"],
  watch: {
    // status(nValue,oValue) {
    //   if(this.status === 2){
    //     this.showReplyTextbox = false;
    //   }else{
    //     this.showReplyTextbox = true;
    //   }
    // },  
  },
  data() {
    return {
      ticket_details: [],
      loading: false,
      reply_loading: false,
      replay: "",
      complete_loading: false,
      incomplete_loading: false,
      close_loading: false,
      status: 0,
      showReplyTextbox: false,
      files: [],
      clientName: "",
      QualityRequest: {},
    };
  },
  created() {
    this.get_ticket_details();
    this.setBreadCrumbs(["الرئيسية", "الدعم الفني", "تفاصيل طلب الدغم الفني"]);
    this.$store.state.opened = -1;
  },
  methods: {
    triggerFileUpload() {
      // Trigger file input when icon is clicked
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      // Handle file selection
      this.files = Array.from(event.target.files);
      this.showPopup("success", `تم رفع ${this.files.length} ملف`);
    },
    clearFiles() {
      this.files = [];
      this.$refs.fileInput.value = '';
    },
    removeFile(index) {
      this.files.splice(index, 1);
      if (this.files.length === 0) {
        this.$refs.fileInput.value = '';
      }
    },
    getFileName(path) {
      return path.split('/').pop() || 'ملف';
    },
    openFile(path) {
      window.open(path, '_blank');
    },

    get_ticket_details() {
      this.loading = true;
      Axios.get(
        `${this.$store.state.url}/employee/collaborator/open-technical-support-request/${this.$route.params.id}?sort_by=created_at&sort_type=asc`,
        { headers: this.request_headers() }
      )
        .then((response) => {
          this.getTopBarData();
          this.ticket_details = response.data.payload.data;
          // this.clientName = response.data.payload.ticket.name;
          this.clientName = response.data.payload.ticket.name + (response.data.payload.ticket.mobile ? ' - ' + response.data.payload.ticket.mobile : '');
          this.QualityRequest = response.data.payload.QualityRequest;

          this.sent_counter = this.ticket_details.length;
          if (response.data.payload.ticket !== undefined) {
            this.status = response.data.payload.ticket?.status;
            this.showReplyTextbox = this.status !== 2;
          }
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    reply_ticket_content() {
      let formData = new FormData();
      formData.append("replay", this.replay);

      if (this.files) {
        if (Array.isArray(this.files)) {
          this.files.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
          });
        } else {
          formData.append("files[0]", this.files);
        }
      }
      this.reply_loading = true;

      Axios.post(
        `${this.$store.state.url}/employee/collaborator/replay-to-technical-support-request/${this.$route.params.id}`,
        formData,
        { headers: this.request_headers() }
      )
        .then(() => {
          this.showPopup("success", "تم الرد بنجاح");
          this.replay = "";
          this.files = [];
          this.$refs.fileInput.value = '';
          this.get_ticket_details();
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        })
        .finally(() => {
          this.reply_loading = false;
        });
    },
    async getTopBarData() {
      await Axios.get(
        `${this.$store.state.url}/agent/topBarCount`,
        {
          headers: this.request_headers(),
        }
      )
        .then((res) => {
          res.data.message.forEach((el) => {
            if (el.technical_support_notifications_count) {
              this.$store.state.supportCount =
                el.technical_support_notifications_count;
              this.technical_support_notifications_count =
                el.technical_support_notifications_count;
            } else if (el.count_of_received_requests) {
              this.$store.state.recievedCount = el.count_of_received_requests;
              this.count_of_received_requests = el.count_of_received_requests;
            }
          });
        })
        .catch((err) => console.log(err));
    },

    reOpenTicket() {
      this.showReplyTextbox = !this.showReplyTextbox;
    },

    to_request_details() {
      const routeURL = this.$router.resolve({
        name: "quality_request_details",
        params: { id: this.QualityRequest.id }
      }).href;
      window.open(routeURL, '_blank');
    },

    changeContentOfButton() {
      if (this.showReplyTextbox === true) {
        return ' الغاء فتح التذكرة';
      } else {
        return 'اعادة فتح التذكرة';
      }
    }
  },
};
</script>

<style lang="scss">
/* Enhanced File Display Styles */
.files-container {
  margin: 8px 0;
  
  .file-item {
    margin-bottom: 8px;
    
    .file-preview {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      background: rgba(77, 32, 77, 0.1);
      border-radius: 8px;
      border: 1px solid rgba(77, 32, 77, 0.2);
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(77, 32, 77, 0.15);
        transform: translateY(-1px);
      }
      
      .file-icon {
        margin-left: 8px;
        display: flex;
        align-items: center;
      }
      
      .file-info {
        flex: 1;
        
        .file-name {
          font-size: 14px;
          font-weight: 500;
          color: #4d204d;
          margin-bottom: 2px;
        }
        
        .file-action {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }
}

/* Dark arrow files styling */
.darkArrow .files-container .file-item .file-preview {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  
  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
  
  .file-info {
    .file-name {
      color: white;
    }
    
    .file-action {
      color: rgba(255, 255, 255, 0.8);
    }
  }
}

/* Enhanced Upload Preview Styles */
.uploaded-files-preview {
  border: 2px dashed #4d204d;
  border-radius: 8px;
  padding: 16px;
  background: rgba(77, 32, 77, 0.05);
  
  .upload-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-weight: 500;
    color: #4d204d;
    font-size: 14px;
  }
  
  .uploaded-files-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    
    .uploaded-file-item {
      .file-preview-upload {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        background: white;
        border-radius: 6px;
        border: 1px solid #e0e0e0;
        
        .file-name-upload {
          flex: 1;
          margin: 0 8px;
          font-size: 13px;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

/* Existing styles remain the same */
.ticket-details-page {
  .v-timeline-item__dot {
    width: 40px !important;
    height: 150px !important;
    border-radius: unset !important;
    clip-path: polygon(0% 0%,
        50% 10%,
        100% 0%,
        100% 85%,
        50% 100%,
        0% 85%,
        0% 0%) !important;

    .v-timeline-item__inner-dot {
      display: none !important;
    }
  }

  .cardo {
    margin-top: 20px !important;
  }

  .v-timeline-item.left-side {
    .v-timeline-item__dot {
      background: #f4b5ff !important;
      border: 1px solid #f4b5ff;
    }

    .cardo {
      &::before,
      &::after {
        transform: rotate(0);
        right: initial !important;
        border: none !important;
        width: 40px !important;
        height: 1px !important;
        background: #f4b5ff !important;
        left: -41px !important;
      }
    }
  }

  .v-timeline-item.right-side {
    .v-timeline-item__dot {
      background: #922595 !important;
      border: 1px solid #922595;
    }

    .cardo {
      &::before,
      &::after {
        border: none !important;
        width: 40px !important;
        height: 1px !important;
        background: #922595 !important;
        left: -41px !important;
      }
    }
  }
}

@media (max-width: 960px) {
  .ticket-details-page {
    .cardo {
      padding-right: 10px;
      padding-left: 10px;
      padding-bottom: 10px;
    }

    .v-timeline-item.right-side {
      .cardo {
        margin-left: 0 !important;

        &::before,
        &::after {
          right: -41px !important;
        }
      }
    }

    .ticket-status-msg {
      margin-right: 0 !important;
    }
  }
}

@media (max-width: 500px) {
  .ticket-details-page {
    .eye-dad {
      .v-card {
        padding: 10px !important;
      }
    }
  }
  
  .files-container .file-item .file-preview .file-info .file-name {
    font-size: 12px;
  }
  
  .uploaded-files-preview .uploaded-files-list .uploaded-file-item .file-preview-upload .file-name-upload {
    font-size: 12px;
  }
}

.right-side {
  flex-direction: row-reverse !important;
}

.right-side .v-timeline-item__opposite {
  text-align: left !important;
}

.left-side {
  flex-direction: row !important;
}

.left-side .v-timeline-item__opposite {
  text-align: right !important;
}

.right-side .v-timeline-item__body .cardo.v-card::after,
.right-side .v-timeline-item__body .cardo.v-card::before {
  right: -42px !important;
}
</style>